export default __webpack_public_path__ + "static/media/gallery_10.585e4e13.jpg";